import React from 'react';
import ReactDOM from 'react-dom';
import reduxThunk from 'redux-thunk';
import { Provider } from 'react-redux';
import { applyMiddleware, createStore } from 'redux';
import i18n from './i18n';
import { I18nextProvider } from 'react-i18next';
import i18next from 'i18next';
import { composeWithDevTools } from 'redux-devtools-extension';

import * as singleSpa from '../init';
import rootReducer from './store';
import configureSentry from '../helpers/SentryUtils';
import { HelmetProvider } from 'react-helmet-async';
import { MetaTags } from './components/MetaTags/MetaTags';
import { SENDBOARD_EDITOR_HASH, SENDBOARD_LOCATION_HASH } from './constants/productsUrlHashes';

import { App } from './containers/App';
import { BrandingProps, getBrandingProps } from '../helpers/brandingHelper';

const middlewares = [reduxThunk];

const store = createStore(
    rootReducer,
    composeWithDevTools(
        applyMiddleware(...middlewares)
        // other store enhancers if any
    )
);

configureSentry();

const rootSetup = (): void => {
    let lang: string;
    const redirectSendboardUrl = (): void => {
        const isInSendBoardEditor: boolean = window.location.hash.includes(SENDBOARD_EDITOR_HASH);

        if (isInSendBoardEditor) {
            location.href = SENDBOARD_LOCATION_HASH;
        }
    };

    const initSingleSpa = (): void => {
        singleSpa.init();

        if (window['DashboardV2']) {
            window['DashboardV2'].globalEventDistributor.registerStore(store);
        }
    };

    const detectAppLanguage = (): void => {
        lang = window.location.href.split('/')[3];
    };

    const branding: BrandingProps = getBrandingProps(window.location.origin);

    const initReactRender = (): void => {
        i18n.changeLanguage(lang).then(() => {
            ReactDOM.render(
                <Provider store={store}>
                    <I18nextProvider i18n={i18n}>
                        <HelmetProvider>
                            <MetaTags lang={lang} title={i18next.t(branding.metatagTitle)} />
                        </HelmetProvider>
                        <App theme={branding.theme} />
                    </I18nextProvider>
                </Provider>,
                document.getElementById('root')
            );
        });
    };

    redirectSendboardUrl();
    initSingleSpa();
    detectAppLanguage();
    initReactRender();
};

rootSetup();
